import { Directive, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl, ValidatorFn } from "@angular/forms";

@Directive()
export abstract class CustomFormControl implements OnInit {

  @Input() extraValidators: ValidatorFn[] = [];
  @Input() initiallyDisabled = false;

  @Output() inputReady: EventEmitter<FormControl> = new EventEmitter<FormControl>();

  public formInput: FormControl;

  constructor() {}

  protected abstract createFormControl(): FormControl;

  public ngOnInit(): void {
    this.formInput = this.createFormControl();
    this.addExtraValidators();
    this.applyInitiallyDisabled();
    this.emitInputIsReady();
  }

  protected addExtraValidators() {
    this.formInput.addValidators(this.extraValidators);
  }

  private emitInputIsReady() {
    this.emitInPromiseToPreventChangeDetection();
  }

  private emitInPromiseToPreventChangeDetection() {
    Promise.resolve().then(() => this.inputReady.emit(this.formInput));
  }

  private applyInitiallyDisabled() {
    if(this.initiallyDisabled) {
      this.formInput.disable();
    }
  }

}